import React, { Component } from 'react';
import { doReviewsubmit, popModal, UpdateState, getState, getSession, AlertMessage, AlertMessageOut, clearSession } from "./function";
import ReactPaginate from 'react-paginate';
import { limit_per_page, name, ApiEndpoint, platform, hideRegion } from "../Constant";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import FileUnsupported from "../Assets/FileUnsupported.png";
import { SearchSelect } from "./searchselect";
import * as axios from 'axios';
import $ from "jquery";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class DataTable extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        id: '',
        page: 1,
        total_page: 1,
        total_result: 0,
        offset: '-1',
        offset_set: 0,
        limit: limit_per_page,
        page_target: '0',
        specific_region: '',
        data: [],
        allDivision: [],
        message: '',
        loading: '',
        retry_times: 0,
      }

      this.clearPagingData = this.clearPagingData.bind(this);
      this.updatePageTarget = this.updatePageTarget.bind(this);
      this.updatePageRegionTarget = this.updatePageRegionTarget.bind(this);
      this.SelectInput = React.createRef();
      }
  
      componentDidMount(){
       var that = this;
       this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      
       //UpdateState(this, 'id', this.props?.match?.params?.id);
      }
  
      componentDidUpdate(prevProps) {
       //this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));
      }
     
      AlertNoTableData = (len) => {
        return <tr><td colspan={len}><div className='p15 center block'>No Table Data - No Result found!</div></td></tr>;
      }
     
     clearPagingData = () => {
        UpdateState(this, 'page', 1);
        UpdateState(this, 'total_page', 1);
        UpdateState(this, 'total_result', 0);
        UpdateState(this, 'offset', '-1');
        UpdateState(this, 'offset_set', 0);
     }

     updatePageTarget(target){
       UpdateState(this, 'page_target', target);
     }

     updatePageRegionTarget(target){
       UpdateState(this, 'specific_region', target);
     }

      handlePageClick = (data) => {

        let selected = data.selected;
        let offset = Math.ceil((selected) * limit_per_page);
         UpdateState(this, 'offset', offset == 0 ? '-1' : offset);
         UpdateState(this, 'offset_set', offset);
         UpdateState(this, 'page', (selected + 1));
         let $specifit = getState(this, 'page_target') == '1' ? '1' : ''; 
         let $specific_region = getState(this, 'specific_region') != '' ? getState(this, 'specific_region') : '';
        if($specific_region != ""){
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '', $specific_region);
        }
        else if($specifit != ""){
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), $specifit, '');
        }
        else{
        this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '', '');
        }
        };
      
      loadDataFromServer = async (cmd, offset, limit, specific = "", specific_region = "") => {
        
        UpdateState(this, 'loading', '1');

        let DeviceSid = await FingerPrint();

        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };
         

         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: this.props.cmd,
            user_id: getSession('userID'),
            division: this.props?.params?.id > 0 && this.props?.params?.id != "" ? this.props?.params?.id : "-1",
            limit: getState(this, 'limit'),
            offset: getState(this, 'offset'),
            page: getState(this, 'page'),
            specific: specific?.length ? specific : '',
            specific_region: specific_region?.length ? specific_region : '',
            type: '',
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');

            if(response.data.retry == true){
             let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
             if(retryTimes != ''){
             if(getState(this, 'retry_times') < 15){
              setTimeout(function(){
             UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
             this.loadDataFromServer(cmd, offset, limit);
              }, 4000);
             }
             }
           }
      
          if(response.data.error == false && response.data.error != true){
         
          UpdateState(this, 'data', response.data.data.length > 0 ? response.data.data : []);
          UpdateState(this, 'allDivision', response.data?.division?.length > 0 ? response.data?.division : []);
          UpdateState(this, 'total_page', response.data.total_page);
          UpdateState(this, 'total_result', response.data.total_result);
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');
            
            $(function() {

            $('.disabled').each(function() {
            //$(this).prop('title', "Disabled and Unavailable for Click Option");
            });
            
            });
       
          }
          else if(response.data.error != false){
            AlertMessage(this, response.data.error, 'error');
            UpdateState(this, 'allDivision', response.data?.division?.length > 0 ? response.data?.division : []);
           UpdateState(this, 'loading', '0');
            if(response.data.logout == true && response.data.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
             UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
           UpdateState(this, 'loading', '0');
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            this.loadDataFromServer(cmd, offset, limit);
        });
      }
  


  render() {
    return ( 
        <>
    <div className="responsive-tables">

  {getState(this, 'loading') == '1' ?
   (<div className="table-loader">
  <div className="overlay">
    <div className="overlay__inner">
        <div className="overlay__content"><span className="spinner"></span></div>
    </div>
</div>
</div>) : ''}

    {AlertMessageOut(this)}


    <div className="card-lt-wraps">
    <div className="card-lts">
    {getSession('contractor') == '1' ? 
    (<> <div style={{backgrounds: '#e9f7f7', padding: '0px 5px 10px 5px', textAlign: 'center', position: 'relative', }}><div className="form-col-row" style={{flexDirection: 'row', justifyContent: 'center', maxWidth: '322px', backgrounds: 'red', margin: '0 auto', }}>
          <div style={{background: '#0766C6', height: '50px', color: '#fff', padding: '15px 15px 15px 15px', display: 'inline-block'}}>Field:</div>
          <SearchSelect 
      defaultValue={this.props?.self?.state?.divisionID} 
      width="322px" borderRadius="0" 
      ref={this.SelectInput} 
      data={getState(this, 'allDivision')} 
      placeholder="Select field of specialization" 
      focusplaceholder="Search field of specialization..." 
      self={this} state="window_transfer"
      target="/publisher/@val" />
     </div></div>
          </>) : (<></>)}

 <div className="tab mtb10">
 <div className="tab-tab tab-label">
     <span className="fa fa-filter"></span>
     </div>
     <div className="tab-link tab-tab active"
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget(''); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'));}}>
     <i className="fa fa-thumbs-up"></i> All
     </div>
     <div className="tab-link tab-tab" 
     onClick={(event) => {this.updatePageTarget('1'); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '1');}}>
     <i className="fa fa-check-circle"></i> Accepted
     </div>
     <div className="tab-link tab-tab" 
     onClick={(event) => {this.updatePageTarget('1'); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '-1');}}>
     <i className="fa fa-times-circle"></i> Rejected
     </div>
     <div className="tab-link tab-tab" hidden={hideRegion}
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget(getSession('region')); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '', getSession('region'));}}>
     <i className="fa fa-map-marker"></i> {getSession('region')}
     </div>
     <div className="tab-link tab-tab" hidden={hideRegion}
     onClick={(event) => {this.updatePageTarget('0'); this.updatePageRegionTarget('-1'); this.clearPagingData(); this.loadDataFromServer(this.props.cmd, getState(this, 'offset'), getState(this, 'limit'), '', '-1');}}>
     <i className="fa fa-globe"></i> Global
     </div>
 </div>
</div>
</div>


<div className="responsive-table">

<div className="publisher-pane hide p15" style={{overflow: 'auto', position: 'relative'}}>
             <div className="greyAlert p15"><div className="publisher-title"> Title :</div> </div>
       
            <div className="card-lt-wraps"><div className="card-lt">
            <div className="commit-tease-left">Script ID: <b style={{fontWeight: 550}} className="publisher-scriptid"></b></div>  
            <div className="commit-tease-left">Author(s): <b style={{fontWeight: 550}} className="publisher-author"></b></div> 
            <div className="commit-tease-left">Affiliations(s): <b style={{fontWeight: 550}} className="publisher-affiliate"></b></div> 
            <div className="commit-tease-left">Submitted date: <b style={{fontWeight: 550}} className="publisher-subdate"></b></div>   
            <div className="commit-tease-left" hidden={hideRegion}>Geo/Region: <b style={{fontWeight: 550}} className="publisher-target"></b></div>
          
            <div className="p15" style={{background: '#e2e2e2', position: 'relative', marginTop: '20px'}}>
            <div className="card-lt-wraps"><div className="card-lt">
        <div className="commit-tease-lefts"><span style={{fontWeight: 550}} className="publisher-summary"></span></div>  
          </div>
          </div>
        </div></div></div></div>

    <table>
        
 <thead><tr>
 <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i} hidden={i == 1 && hideRegion}>{th}</th>
     })}
 </tr>
 </thead>

 <tbody>
     
 {getState(this, 'data')?.length == 0 ? this.AlertNoTableData(this.props.th.length + 1) : ''}
 {getState(this, 'data')?.map((td, i) => {
        
    let R1 = td['publisher_button']['r1'] == '0' ? 'disabled' : '';
    let F1 = td['file_button']['f1'] == '0' ? 'disabled' : '';

    let R2 = td['publisher_button']['r2'] == '0' ? 'disabled' : '';
    let F2 = td['file_button']['f2'] == '0' ? 'disabled' : '';

    let R3 = td['publisher_button']['r3'] == '0' ? 'disabled' : '';
    let F3 = td['file_button']['f3'] == '0' ? 'disabled' : '';
    //alert(td['review_button']['r1']+""+td['feedback_button']['f1']);
   return(
     <tr key={i}>
     <td key={i}> {i+1} </td>
     <td>{td['scriptID']}</td>
     <td hidden={hideRegion}>{td['target']}</td>

     <td>
     <div className="chip-flex">
         <button disabled={R1} className={"chip primaryX " +R1} 
          data-modalData={td['scriptID']}
           title="File for Review 1"
           > {td['files']['r1']['file_ext']?.toUpperCase()} </button>
         <button disabled={F1} className={"chip " +td['score']['f1']['vote_class']+ " " +F1}
         data-modalData={td['scriptID']} title="Feedback Score for Review 1"> <i className={td['score']['f1']['vote_icon']} aria-hidden="true"></i> {td['score']['f1']['vote']} </button>
         </div>
         </td>
     
     <td>
      <div className="chip-flex">
      <button disabled={R2} className={"chip primaryX " +R2} 
          data-modalData={td['scriptID']}
            title="File for Review 2"
           > {td['files']['r2']['file_ext']?.toUpperCase()} </button>
         <button disabled={F2} className={"chip " +td['score']['f2']['vote_class']+ " " +F2}
         data-modalData={td['summary']} title="Feedback Score for Review 2"> <i className={td['score']['f2']['vote_icon']} aria-hidden="true"></i> {td['score']['f2']['vote']} </button>
         </div>
         </td>

         <td>
       <div className="chip-flex">
       <button disabled={R3} className={"chip primaryX " +R3} 
           data-modalData={td['scriptID']}
            title="File for Review 3"
           > {td['files']['r3']['file_ext']?.toUpperCase()} </button>
         <button disabled={F3} className={"chip " +td['score']['f3']['vote_class']+ " " +F3}
         data-modalData={td['summary']} title="Feedback Score for Review 3"> <i className={td['score']['f3']['vote_icon']} aria-hidden="true"></i> {td['score']['f3']['vote']} </button>
         </div>
         </td>
         
         <td className="nowrap">
        {td['file_visibility'] && td['file_visibility'] == true ?
        (<button data-self={this} data-file-url={td['file_url']} data-scriptid={td['scriptID']} data-scriptauthor={td['author']} data-scripttitle={td['title']} data-scriptsummary={td['summary']} data-scripttarget={td['target']} data-scriptsubdate={td['subdate']} data-scriptaffiliate={td['affiliate']} className={"download-publisher btn-activeable "+td['subclass']+" chip primaryX"}><i className="fa fa-download"></i> Download</button>)
        : (<button data-file-url="#no-file" data-scriptid={td['scriptID']} data-scriptauthor={td['author']} data-scripttitle={td['title']} data-scripttarget={td['target']} data-scriptsubdate={td['subdate']} data-scriptaffiliate={td['affiliate']} className={"download-publisher btn-activeable "+td['subclass']+" chip primaryX disabled"} disabled="disabled"><i className="fa fa-download"></i> Download</button>)}
             {/*td['note']*/}</td>
    </tr>
    );
     })}

     </tbody>

    <tfoot><tr>
    <th>S/N</th>
     {this.props.th?.map((th, i) => {
      return <th className={this.props.thclassX[i]} key={i} hidden={i == 1 && hideRegion}>{th}</th>
     })}
 </tr>
 </tfoot>

</table>
</div>

<div className="card-lt">  

<div>Page: {getState(this, 'page')} of {getState(this, 'total_page')} ⟺ ☆ Result: {parseInt(getState(this, 'offset_set')) + parseInt(1)} - {Math.ceil(getState(this, 'page') * limit_per_page) >= getState(this, 'total_result') ? getState(this, 'total_result') : Math.ceil(getState(this, 'page') * limit_per_page)} of {getState(this, 'total_result')}</div>

<ReactPaginate
          previousLabel={'« Prev'}
          nextLabel={'Next »'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={getState(this, 'total_page')}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
 </div>
</div>
</>
);
}
}

export default DataTable;